import React, { Component } from "react";
import MedicalConsentHeader from "../../components/medicalconsent/MedicalConsentHeader";
import DisplayValidationErrors from "../../components/shared/DisplayValidationErrors";
import TextInput from "../../components/shared/form/TextInput";
import Content from "../../content/Content";
import Store from "../../content/Store";
import { Link } from "react-router-dom";
import TextAreaInput from "./../shared/form/TextAreaInput";
import ClaimNumberValidation from "../../validations/ClaimNumberValidation";
import { isFieldDefined } from "../../validations/RequiredFieldValidator";
import PhoneNumberValidation from "../../validations/PhoneNumberValidation";
import Button from "../shared/buttons/Button";

export default class ProvideMedicalConsent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessages: [],
      claimNumberHasError: false,
      fullNameHasError: false,
      addressHasError: false,
      phoneNumberHasError: false
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.validate = this.validate.bind(this);
  }

  onSubmit(event) {
    event.preventDefault();
    let errorMessages = this.validate();

    if (errorMessages.length === 0) {
      this.props.provideMemberdetailsOnSubmit(event);
    } else {
      this.setState({
        errorMessages: errorMessages
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  validate() {
    let localErrorMessages = [];
    let isClaimNumberDefined = isFieldDefined(
      this.props.medicalConsent.claimNumber
    );
    let isFullNameDefined = isFieldDefined(this.props.medicalConsent.fullName);
    let isAddressDefined = isFieldDefined(this.props.medicalConsent.address);
    let isPhoneNumberDefined = isFieldDefined(
      this.props.medicalConsent.phoneNumber
    );
    let isClaimNumberValid = ClaimNumberValidation(
      this.props.medicalConsent.claimNumber,
      this.props.isFormat2
    );
    let isPhoneNumberValid = PhoneNumberValidation(
      this.props.medicalConsent.phoneNumber
    );

    if (
      !isClaimNumberDefined ||
      !isFullNameDefined ||
      !isAddressDefined ||
      !isPhoneNumberDefined
    ) {
      localErrorMessages.push(
        Store.MedicalConsent.ValidationErrors.AllFieldsRequired
      );
    }

    if (isClaimNumberDefined && !isClaimNumberValid) {
      localErrorMessages.push(
        Store.MedicalConsent.ValidationErrors.ClaimNumberInvalidFormat
      );
    }

    if (isPhoneNumberDefined && !isPhoneNumberValid) {
      localErrorMessages.push(
        Store.MedicalConsent.ValidationErrors.PhoneNumberInvalidFormat
      );
    }

    this.setState({
      claimNumberHasError: !isClaimNumberValid,
      fullNameHasError: !isFullNameDefined,
      addressHasError: !isAddressDefined,
      phoneNumberHasError: !isPhoneNumberValid
    });

    return localErrorMessages;
  }

  render() {
    return (
      <React.Fragment>
        <MedicalConsentHeader
          pageTitle={this.props.pageTitle}
          pageBody={this.props.pageBody}
        />

        <DisplayValidationErrors
          heading={this.props.errorValidationHeading}
          errors={this.state.errorMessages}
        />

        <form onSubmit={event => this.onSubmit(event)}>
          <TextInput
            hasError={this.state.claimNumberHasError}
            inputId="claimNumber"
            label={
              <Content
                name={Store.MedicalConsent.MedicalConsentClaimInput.Label}
              />
            }
            onChange={this.props.onChange}
            inputValue={this.props.medicalConsent.claimNumber}
            tooltipContent={
              <Content
                name={Store.MedicalConsent.MedicalConsentClaimInput.Tooltip}
              />
            }
            gradientClass="secondary"
          />
          <TextInput
            inputId="fullName"
            label={
              <Content
                name={
                  Store.MedicalConsent.ProvideMedicalConsentInput
                    .LeadMemberFullNameLabel
                }
              />
            }
            inputValue={
              this.props.medicalConsent
                ? this.props.medicalConsent.fullName
                : ""
            }
            hasError={this.state.fullNameHasError}
            disabled={this.props.isAxaLayout ? true : undefined}
            onChange={this.props.onChange}
          />
          <TextAreaInput
            inputId="address"
            label={
              <Content
                name={
                  Store.MedicalConsent.ProvideMedicalConsentInput
                    .LeadMemberAddressLabel
                }
              />
            }
            inputValue={
              this.props.medicalConsent ? this.props.medicalConsent.address : ""
            }
            hasError={this.state.addressHasError}
            disabled={this.props.isAxaLayout ? true : undefined}
            onChange={this.props.onChange}
            rows="5"
          />

          <TextInput
            inputId="membershipNumber"
            label={
              <Content
                name={
                  Store.MedicalConsent.ProvideMedicalConsentInput
                    .MembershipnumberLabel
                }
              />
            }
            inputValue={
              this.props.medicalConsent
                ? this.props.medicalConsent.membershipNumber
                : ""
            }
            disabled={true}
            onChange={this.props.onChange}
          />
          <TextInput
            inputId="phoneNumber"
            label={
              <Content
                name={
                  Store.MedicalConsent.ProvideMedicalConsentInput
                    .PhoneNumberLabel
                }
              />
            }
            inputValue={
              this.props.medicalConsent
                ? this.props.medicalConsent.phoneNumber
                : ""
            }
            autoComplete="off"
            hasError={this.state.phoneNumberHasError}
            onChange={this.props.onChange}
          />
          <Content name={Store.MedicalConsent.PhoneNumberNote} />
          <TextInput
            inputId="emailAddress"
            label={
              <Content
                name={
                  Store.MedicalConsent.ProvideMedicalConsentInput
                    .EmailAddressLabel
                }
              />
            }
            autoComplete="off"
            inputValue={
              this.props.medicalConsent
                ? this.props.medicalConsent.emailAddress
                : ""
            }
            disabled={true}
            onChange={this.props.onChange}
          />
          <div className="row my-5">
            <div className="col-sm-6 back-button">
              <p className="axa-body-text-4 mt-2">
                <Link
                  id="backButton"
                  to=""
                  onClick={event =>
                    this.props.previousContentHandleBackClick(event)
                  }
                >
                  <span className="mr-2 left-arrow-back">←</span>{" "}
                  {this.props.buttonBackText}
                </Link>
              </p>
            </div>
            <div
              className="col-sm-6 text-right"
              id="provideMemberDetailsSubmitButton"
            >
              <Button label={this.props.nextButton} />
            </div>
          </div>
        </form>
      </React.Fragment>
    );
  }
}
